export var makeFormGroupStyles = function makeFormGroupStyles(_ref) {
  var primitives = _ref.primitives;
  return {
    MuiFormGroup: {
      styleOverrides: {
        root: {
          "& label": {
            marginBottom: primitives.spacings[1]
          }
        }
      }
    }
  };
};